import { Box, Stack, Typography, useTheme } from '@mui/material';
import SendDialog from './SendDialog';
import CoinsBoxIcon from '../../../components/icons/CoinsBox';
import React, { useState, useEffect, useRef } from 'react';
import { LottieRefCurrentProps } from 'lottie-react';
import animationData from '../../../components/animations/pielapay-lottie.json';
import PaymentIcon from '../../../components/icons/PaymentIcon';
import ReactLoading from 'react-loading';
import FileSuccessIcon from '../../../components/icons/FileSuccessIcon';
import Button from '../../../components/custom/Button';
import { useNavigate } from 'react-router-dom';

type SendStatus = 'PENDING' | 'IN_PROGRESS' | 'PAID' | 'COMPLETED';

interface SendButtonProps {
  status: SendStatus;
  fileId: string;
  amount: number;
  employees: number; // Общее количество записей сотрудников (file.employees.length)
  deposits: number;
  depositsArray: any;
  uniqueEmployees: number; // Количество уникальных employeeId (теудат зеут)
  uniqueEmployeesForFees: number; // Количество сотрудников для комиссии с учетом месяцев
  salaryMonth: string;
}

const SendButton: React.FC<SendButtonProps> = ({
  status,
  fileId,
  amount,
  employees,
  deposits,
  depositsArray,
  uniqueEmployees,
  uniqueEmployeesForFees,
  salaryMonth,
}) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const theme = useTheme();

  const navigate = useNavigate();

  const isClickable = status === 'PENDING';

  useEffect(() => {
    const animationInstance = lottieRef.current;

    if (!animationInstance) {
      return;
    }

    switch (status) {
      case 'IN_PROGRESS':
        animationInstance.goToAndStop(0, true);
        break;
      case 'COMPLETED':
        animationInstance.goToAndStop(63, true);
        break;
      case 'PENDING':
      default:
        animationInstance.stop();
        break;
    }
  }, [status]);

  useEffect(() => {
    if (
      !animationData &&
      (status === 'IN_PROGRESS' || status === 'COMPLETED')
    ) {
      console.error('Lottie animation data is missing or invalid!');
    }
  }, [status]);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const renderButtonContent = () => {
    switch (status) {
      case 'PENDING':
        return <Stack alignItems={'center'} spacing={1}>
          <CoinsBoxIcon />
          <Typography
            fontWeight={'700'}
            fontSize={'16px'}
            fontFamily={'AlmoniDL'}
          >
            לחץ לתשלום ושליחת נתונים
          </Typography>
        </Stack>;
      case 'IN_PROGRESS':
        return  <Stack spacing={1} alignItems={'center'}>
          <ReactLoading
        type={'bubbles'}
        color={theme.palette.green.main}
        height={100}
        width={100}
      />
      <Typography
        fontWeight={'700'}
        fontSize={'16px'}
        fontFamily={'AlmoniDL'}
      >
        ממתינים לאישור תשלום
      </Typography>
        </Stack>;
      case 'PAID':
        return <Stack spacing={1} alignItems={'center'}>
          <PaymentIcon />
          <Stack spacing={0.5}>
            <Typography
              fontWeight={'700'}
              fontSize={'18px'}
              fontFamily={'AlmoniDL'}
              textAlign={'center'}
            >
              !התשלום אושר
            </Typography>
            <Typography
              fontWeight={'700'}
              fontSize={'12px'}
              fontFamily={'AlmoniDL'}
              textAlign={'center'}
            >
              .כעת הנתונים נשלחים לחברות הביטוח
            </Typography>
          </Stack>
        </Stack>;
      case 'COMPLETED':
        return <Stack alignItems={'center'}>
          <FileSuccessIcon />
          <Typography
          dir='rtl'
              fontWeight={'700'}
              fontSize={'18px'}
              fontFamily={'AlmoniDL'}
              textAlign={'center'}
              mb='20px'
            >
              הנתונים נקלטו בהצלחה!
            </Typography>
            <Button onClick={() => navigate(`/employees`)}>צפייה בפרטים</Button>
        </Stack>
        
      default:
        return <CoinsBoxIcon />;
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Box
        onClick={isClickable ? handleOpenDialog : undefined}
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#DAE2EA',
          px: '20px',
          py: '10px',
          borderRadius: '30px',
          gap: '10px',
          cursor: isClickable ? 'pointer' : 'default',
        }}
      >
        {renderButtonContent()}
      </Box>
      <SendDialog
        fileId={fileId}
        amount={amount}
        employees={employees}
        deposits={deposits}
        depositsArray={depositsArray}
        uniqueEmployees={uniqueEmployees}
        uniqueEmployeesForFees={uniqueEmployeesForFees}
        salaryMonth={salaryMonth}
        open={dialogOpen}
        onClose={handleCloseDialog}
      />
    </Box>
  );
};

export default React.memo(SendButton);
